export enum HeatingDistributionMethod {
    Radiator = 'RADIATOR',
    Underfloor = 'UNDERFLOOR_HEATING',
    RadiatorAndUnderfloor = 'MIXED'
}
